import {configureStore} from '@reduxjs/toolkit'
import headerSlice from '../features/common/headerSlice'
import modalSlice from '../features/common/modalSlice'
import shopsSlice from '../features/tiktokshop/slices/shopsSlice'
import variationsSlice from '../features/tiktokshop/slices/variationsSlice'
import productSlice from '../features/tiktokshop/slices/productSlice'
import rightDrawerSlice from '../features/common/rightDrawerSlice'
import leadsSlice from '../features/leads/leadSlice'

const combinedReducer = {
    header: headerSlice,
    rightDrawer: rightDrawerSlice,
    modal: modalSlice,
    shops: shopsSlice,
    variations: variationsSlice,
    product: productSlice,
    lead: leadsSlice
}

export default configureStore({
    reducer: combinedReducer
})